export default "__VITE_ASSET__BjitJbNj__"